const FlagMexico = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="16"
            height="16"
        >
            <image
                width="12"
                height="12"
                preserveAspectRatio="none"
                transform="scale(1.33333)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAfxJREFUOI2Fk89rE2EQhp/dxK6JhhYNVrSU1YoErGUVexHR7aHSiFALIggFEQRrIBovEvCQ+geUpIpXjXryIFY9thLwICKaLqkHxTQpWo2INqFpDjG24yXbH0kkz22+b953vhnmgxpExBSRqIhkZY1pEbkvInpt/ip6yGx7+PJpVJqQOncjmsBos3WqLd76x5X4NJ8J/bdClcrPhdAyJGwTFcBTdkUQjGbidRgrEAFQfSMDukDDysPDw4TD4YYOAqFJDFN1oEZqL8ulIi9uX+biUYXOTbMEAgGKxWKdiQJnnIoiG56+WMjx6tFdpr9+ZD6VI5EFBYjH4wSDwVqDQRXWes8XciTfjLHziJdj/gu0KK34tjnQtzv49v0zC/lcbRu6c/1BOpPk16JGZ08XkzNzzPwu0+vewsl2H+9+pElnkmwQAKoCc3bgdnv4gos7by2eWB9Q3W7KmpfKciuzpUKjWVqqCM/saN/eXroOn+BvJUV/PotZWoIVB/c6PAycP8vBA8frDJwgE6BcA9BaXAyeusoO7y5edzyn53GBikC5v52h09frylfgFgDdI/5Y9xW/3Hww1myT5b15SaYwZAojBtVNdG7WRgGrUZONELCKMLpqYMUmCk5N69u/e894M7HnkG98CfqGsBpOFRHRRSRe/cI2WRGJiYhZm/8PpSYS14cn2qAAAAAASUVORK5CYII="
            />
        </svg>
    )
}

export default FlagMexico
